// Wishlist
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;

    if (button.dataset.loggedIn === 'false') {
      window.location.href = button.dataset.loginUrl;
      return;
    }

    if (button.classList.contains('is-loading')) return;

    var productId = button.dataset.productId;

    button.classList.add('is-loading');

    fetch('/apps/wishlist/toggle', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product_id: productId })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Wishlist request failed');
        return response.json();
      })
      .then(function (data) {
        var inWishlist = data.in_wishlist;
        button.classList.toggle('is-active', inWishlist);
        button.setAttribute('aria-pressed', String(inWishlist));
        button.setAttribute(
          'aria-label',
          inWishlist ? button.dataset.labelRemove : button.dataset.labelAdd
        );
        document.dispatchEvent(
          new CustomEvent('wishlist:updated', {
            detail: { productId: productId, inWishlist: inWishlist, count: data.count }
          })
        );
      })
      .catch(function (error) {
        console.error('[Wishlist]', error);
      })
      .finally(function () {
        button.classList.remove('is-loading');
      });
  });
})();

document.addEventListener('change', function(event) {
  const checkbox = event.target.closest('[data-gift-wrapping]');
  if (!checkbox) return;

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      attributes: { 'Envolver para regalo': checkbox.checked ? 'Sí' : '' }
    })
  });
});

// Revi reviews: convertir el listado de reviews en galería swipeable.
// El HTML lo inyecta el script de Revi (App Block), no es nuestro Liquid, así que
// se observa su contenedor y se reagrupan las reviews en <scroll-carousel> en
// cuanto Revi termina de pintarlas. Selector acotado al widget (no document.body)
// para no reaccionar a mutaciones ajenas de la página.
(function () {
  var REVI_WIDGET_SELECTOR = '[id*="revi_io_reviews_widget_product"]';
  var REVI_PANE_SELECTOR = '.revi-product__pane';
  var REVI_REVIEW_SELECTOR = '.revi-review__container';
  var DEBOUNCE_MS = 150;

  var ARROW_LEFT_SVG = '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="M11 1 3 9l8 8" stroke="currentColor" stroke-linecap="square"/></svg>';
  var ARROW_RIGHT_SVG = '<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 18"><path d="m5 17 8-8-8-8" stroke="currentColor" stroke-linecap="square"/></svg>';

  function createNav(carouselId, slideCount) {
    // ScrollCarousel decide en su constructor (no en connectedCallback) si añade los
    // listeners de scroll/drag, y solo lo hace si this.allCells.length > 1 en ESE momento
    // (this.children, evaluado una sola vez). Si el elemento se crea vacío y los slides se
    // añaden después con appendChild, el constructor ya pasó con 0 hijos y nunca se
    // reevalúa. Por eso se parsea de una vez el <scroll-carousel> ya con sus N slides
    // (vacíos, como placeholders) y los atributos puestos, para que el constructor los
    // vea todos desde el principio — igual que cuando Prestige lo escribe en Liquid.
    // Las flechas reutilizan <carousel-prev-button>/<carousel-next-button>, los mismos
    // componentes nativos que usa product-gallery (requieren aria-controls -> id del carrusel).
    var slidesHtml = '';
    for (var i = 0; i < slideCount; i++) {
      slidesHtml += '<div class="snap-center"></div>';
    }

    var wrapper = document.createElement('div');
    wrapper.innerHTML =
      '<div class="revi-reviews__nav">' +
        '<carousel-prev-button aria-controls="' + carouselId + '" class="contents">' +
          '<button type="button" class="circle-button circle-button--sm revi-reviews__arrow revi-reviews__arrow--prev">' +
            '<span class="sr-only">Anterior</span>' + ARROW_LEFT_SVG +
          '</button>' +
        '</carousel-prev-button>' +
        '<scroll-carousel id="' + carouselId + '" class="revi-reviews__carousel scroll-area" adaptive-height allow-drag>' + slidesHtml + '</scroll-carousel>' +
        '<carousel-next-button aria-controls="' + carouselId + '" class="contents">' +
          '<button type="button" class="circle-button circle-button--sm revi-reviews__arrow revi-reviews__arrow--next">' +
            '<span class="sr-only">Siguiente</span>' + ARROW_RIGHT_SVG +
          '</button>' +
        '</carousel-next-button>' +
      '</div>';
    return wrapper.firstElementChild;
  }

  function convertPane(pane) {
    if (pane.hasAttribute('data-revi-gallery-applied')) return;

    var reviews = pane.querySelectorAll(REVI_REVIEW_SELECTOR);
    if (reviews.length === 0) return;

    var nav = createNav('revi-reviews-carousel--' + pane.id, reviews.length);
    var carousel = nav.querySelector('.revi-reviews__carousel');
    var slides = carousel.children;

    reviews.forEach(function (review, index) {
      slides[index].appendChild(review);
    });

    pane.appendChild(nav);
    pane.setAttribute('data-revi-gallery-applied', 'true');
  }

  document.querySelectorAll(REVI_WIDGET_SELECTOR).forEach(function (widget) {
    var debounceTimeout;

    function scheduleConvert() {
      clearTimeout(debounceTimeout);
      debounceTimeout = setTimeout(function () {
        widget.querySelectorAll(REVI_PANE_SELECTOR).forEach(convertPane);
      }, DEBOUNCE_MS);
    }

    new MutationObserver(scheduleConvert).observe(widget, { childList: true, subtree: true });
    scheduleConvert();
  });
})();